document.addEventListener('DOMContentLoaded', function () {
  const megaMenuWrapper = document.getElementById('mega-menu-wrapper');
  const megaMenuHeader = document.getElementById('mega-menu-header');
  const megaMenuPanels = document.querySelector('.mega-menu-panels');
  const announcementBar = document.getElementById('announcement-bar');
  const panels = {
    panel1: document.getElementById('mega-menu-panel-1'),
    panel2: document.getElementById('mega-menu-panel-2'),
    panel3: document.getElementById('mega-menu-panel-3'),
    panel4: document.getElementById('mega-menu-panel-4'),
  };

  const showAds = window.showAdvertisement || false;
  let currentPanelState = null;
  let lastScroll = 0;
  let resizeTimeout = null;
  let previousScreenSize = null;

  function updateMegaMenuHeight() {
    const baseHeight = announcementBar ? 112 : 80;
    megaMenuPanels.style.height = `calc(100dvh - ${baseHeight}px)`;
  }

  updateMegaMenuHeight();

  // Initial check for responsive menu state
  handleResponsiveMenuSwitch();

  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 0)
      window.addForceNavbarWhite();
    else
      window.removeForceNavbarWhite();
  });

  function hidePanel(panel) {
    if (!panel) return;
    panel.classList.add('invisible', 'hidden');
  }

  function togglePanel(panel, show) {
    if (!panel) return;
    if (show) {
      panel.classList.remove('invisible', 'hidden');
    } else {
      panel.classList.add('invisible', 'hidden');
    }
  }

  window.hideAllPanels = function() {
    currentPanelState = null;
    megaMenuPanels.classList.remove('panel-1-only', 'panels-1-2', 'all-panels');
    megaMenuPanels.classList.add('w-0', 'invisible');
    megaMenuPanels.style.width = '0';
    
    Object.values(panels).forEach(panel => togglePanel(panel, false));
    document.querySelectorAll('[id^="mega-menu-panel-1-"], [id^="mega-menu-panel-2-"], [id^="mega-menu-panel-3-"]')
      .forEach(panel => panel.classList.add('hidden'));
    
    // Clear active link
    window.activeMegaMenuLink = null;
    
    setTimeout(() => {
      megaMenuWrapper.classList.remove('bg-white', 'menu-open');
      
      // Clean up mega menu carousels
      if (window.megaMenuCarousels) {
        Object.values(window.megaMenuCarousels).forEach(carousel => {
          if (carousel) carousel.destroy();
        });
        window.megaMenuCarousels = {};
      }
    }, 300);
  }

  function getPanelWidth() {
    const width = window.innerWidth;
    if (width >= 1600) {
      return 533;
    }
    return (width * 0.33333);
  }

  function showPanels(config = {}) {
    const visiblePanels = config.panels || ['panel1'];
    const showAd = config.showAd && showAds;
    
    currentPanelState = config.state || 'panel1';
    const panelWidth = getPanelWidth();
    
    megaMenuPanels.classList.remove('w-0', 'invisible', 'panel-1-only', 'panels-1-2', 'all-panels');
    megaMenuWrapper.classList.add('bg-white', 'menu-open');
    
    // Update individual panel widths
    Object.values(panels).forEach(panel => {
      if (panel)
        panel.style.setProperty('width', `${panelWidth}px`, 'important');
    });
    
    if (visiblePanels.length === 1) {
      megaMenuPanels.style.width = `${panelWidth}px`;
    } else if (visiblePanels.length === 2 && !showAd) {
      megaMenuPanels.classList.add('panels-1-2');
      megaMenuPanels.style.width = `${panelWidth * 2}px`;
    } else {
      megaMenuPanels.classList.add('all-panels');
      megaMenuPanels.style.width = `${panelWidth * 3}px`;
    }
    
    Object.keys(panels).forEach(key => {
      const show = visiblePanels.includes(key) || (key === 'panel4' && showAd);
      togglePanel(panels[key], show);
      
      if (key === 'panel4' && showAd) {
        panels.panel4.style.position = 'absolute';
        panels.panel4.style.left = `${panelWidth * 2}px`;
        panels.panel4.style.zIndex = '100';
      }
    });
    
    if (config.checkContent && visiblePanels.includes('panel2')) {
      setTimeout(() => {
        const visiblePanel2 = document.querySelector('[id^="mega-menu-panel-2-"]:not(.hidden)');
        const hasContent = visiblePanel2 && (visiblePanel2.querySelector('[data-submenu="true"]') || 
                        visiblePanel2.querySelector('.navigation-product'));
        
        if (!hasContent && showAds) {
          showPanels({panels: ['panel1', 'panel2'], showAd: true, state: 'panels1And2WithAd'});
        }
      }, 10);
    }
    
    // Initialize carousels after panels are visible
    setTimeout(() => {
      window.initializeMenuCarousels();
    }, 200);
  }

  window.startMegaMenuUnfold = function(id) {
    clearTimeout(window.panelTimeout);
    
    window.panelTimeout = setTimeout(() => {
      const subPanel = document.getElementById(id);
      
      if (!subPanel) {
        // If there's no subPanel, it means it's a link without submenu
        // In this case, we close all panels
        hideAllPanels();
        return;
      }

      showPanels({panels: ['panel1']});
      
      document.querySelectorAll('[id^="mega-menu-panel-1-"]').forEach(p => p.classList.add('hidden'));
      subPanel.classList.remove('hidden');
      
      // Get the link title from the panel ID
      const panelIndex = id.split('-').pop();
      const menuLinks = document.querySelectorAll('.nav-link');
      const activeLink = menuLinks[panelIndex - 1];
      const linkTitle = activeLink ? activeLink.textContent.trim() : '';
      
      // Store the active link title for carousel initialization
      window.activeMegaMenuLink = linkTitle;
      
      // Initialize carousels after panel is visible
      setTimeout(() => {
        window.initializeMenuCarousels();
      }, 200);
    }, 100);
  };

  panels.panel1.addEventListener('mousemove', (event) => {
    const menuItem = event.target.closest('.mega-menu-item');

    if (!menuItem) {
      showPanels({panels: ['panel1']});
      hidePanel(panels.panel2);
      hidePanel(panels.panel3);
      hidePanel(panels.panel4);
      document.querySelectorAll('[id^="mega-menu-panel-2-"], [id^="mega-menu-panel-3-"]').forEach(p => p.classList.add('hidden'));
      panels.panel2.classList.remove('visible');
      panels.panel3.classList.remove('visible');
    }
  });

  window.handlePanel1ItemHover = function(el, panel2Id) {
    clearTimeout(window.panelTimeout);
    
    window.panelTimeout = setTimeout(() => {
      const subPanel = document.getElementById(panel2Id);
      const hasSubmenu = el.dataset.submenu === 'true';

      if (!hasSubmenu) {
        showPanels({panels: ['panel1']});
        return;
      }

      document.querySelectorAll('[id^="mega-menu-panel-2-"]').forEach(p => p.classList.add('hidden'));
      if (subPanel) {
        subPanel.classList.remove('hidden');
        panels.panel2.classList.add('visible');
        showPanels({
          panels: ['panel1', 'panel2'],
          showAd: true,
          state: 'panels1And2WithAd'
        });
      }
    }, 50);
  };

  panels.panel2.addEventListener('mouseover', (event) => {
    const menuItem = event.target.closest('.mega-menu-item');
    
    if (panels.panel3.classList.contains('visible') || 
        document.querySelector('[id^="mega-menu-panel-3-"]:not(.hidden)')) {
      return;
    }
    
    if (!menuItem) {
      showPanels({
        panels: ['panel1', 'panel2'],
        showAd: true,
        state: 'panels1And2WithAd'
      });
    }
  });

  window.showSubPanel = function(panelId) {
    clearTimeout(window.panelTimeout);
    
    window.panelTimeout = setTimeout(() => {
      const subPanel = document.getElementById(panelId);
      const hasContent = subPanel && subPanel.querySelector('a');
      
      if (!hasContent) {
        showPanels({
          panels: ['panel1', 'panel2'],
          showAd: true,
          state: 'panels1And2WithAd'
        });
        return;
      }
      
      showPanels({panels: ['panel1', 'panel2', 'panel3'], state: 'panels1And2And3'});
      panels.panel3.classList.add('visible');
      
      document.querySelectorAll('[id^="mega-menu-panel-3-"]').forEach(p => p.classList.add('hidden'));
      subPanel.classList.remove('hidden');
    }, 50);
  };

  panels.panel3.addEventListener('mouseleave', (event) => {
    if (!panels.panel3.contains(event.relatedTarget)) {
      panels.panel3.classList.remove('visible');
      showPanels({
        panels: ['panel1', 'panel2'],
        showAd: true,
        state: 'panels1And2WithAd'
      });
    }
  });

  document.addEventListener('click', (event) => {
    if (!megaMenuWrapper.contains(event.target))
      hideAllPanels();
  });

  // Handle window resize to update panel widths
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    
    resizeTimeout = setTimeout(() => {
      // Handle responsive menu switching
      handleResponsiveMenuSwitch();
      
      updateMegaMenuHeight();
      
      // If menu is currently open, recalculate panel widths
      if (megaMenuWrapper.classList.contains('menu-open') && currentPanelState) {
        updatePanelWidths();
      }
      
      // Reinitialize carousel if menu is open
      if (megaMenuWrapper.classList.contains('menu-open')) {
        window.initializeMenuCarousels();
      }
    }, 150);
  });

  function updatePanelWidths() {
    const panelWidth = getPanelWidth();
    const visiblePanels = getVisiblePanelsFromState(currentPanelState);
    
    // Update individual panel widths
    Object.values(panels).forEach(panel => {
      if (panel) {
        panel.style.setProperty('width', `${panelWidth}px`, 'important');
      }
    });
    
    // Update container width
    if (visiblePanels.length === 1) {
      megaMenuPanels.style.width = `${panelWidth}px`;
    } else if (visiblePanels.length === 2) {
      megaMenuPanels.style.width = `${panelWidth * 2}px`;
    } else {
      megaMenuPanels.style.width = `${panelWidth * 3}px`;
    }
    
    // Update panel4 position if it exists
    if (panels.panel4 && panels.panel4.style.position === 'absolute') {
      panels.panel4.style.left = `${panelWidth * 2}px`;
    }
  }

  function getVisiblePanelsFromState(state) {
    switch (state) {
      case 'panel1':
        return ['panel1'];
      case 'panels1And2WithAd':
        return ['panel1', 'panel2'];
      case 'panels1And2And3':
        return ['panel1', 'panel2', 'panel3'];
      default:
        return ['panel1'];
    }
  }

  function handleResponsiveMenuSwitch() {
    const isDesktop = window.innerWidth >= 1024; // lg breakpoint
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileMenuContainer = document.getElementById('mobile-menu-container');
    
    // Only handle switching if screen size actually changed
    if (previousScreenSize === null) {
      previousScreenSize = isDesktop ? 'desktop' : 'mobile';
      return;
    }
    
    const currentScreenSize = isDesktop ? 'desktop' : 'mobile';
    if (previousScreenSize === currentScreenSize) {
      return;
    }
    
    // If switching from mobile to desktop
    if (isDesktop && mobileMenu && !mobileMenu.classList.contains('hidden')) {
      // Close mobile menu
      mobileMenuContainer.classList.add('-translate-x-full');
      setTimeout(() => {
        mobileMenu.classList.add('hidden');
      }, 300);
    }
    
    // If switching from desktop to mobile and mega menu is open
    if (!isDesktop && megaMenuWrapper.classList.contains('menu-open')) {
      // Close mega menu
      hideAllPanels();
    }
    
    previousScreenSize = currentScreenSize;
  }
}); 